// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-aster -> rebel-residential-aster -> aster
// Generated: 2026-09-11T19:09:13.995Z
// Counts: 2 design, 57 content, 16 slot group, 1 collection binding, 6 section, 0 style

export const designOverrides = {
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#707070",
    "mappedField": null
  },
  "design.SpecialOfferBanner.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Accessibility</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_amenities_blurb"
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Amenities</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Amenities</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.intro": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Welcome to a world of unmatched luxury and convenience at <span data-type=\"field-token\" data-field=\"property_name\"></span>. Our amenity offerings redefine the standard of modern living, providing an exquisite backdrop to complement your lifestyle.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.interiorHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_applynow_blurb"
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Apply Now</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_contactus_blurb"
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Contact Us</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "conveniencecallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "conveniencecallout.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Convenience All Around</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_floorplans_blurb"
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Floor Plans</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.feature_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.feature_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Spacious Apartment Homes</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.contact_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Contact</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.follow_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Follow Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.office_hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Office Hours</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.visit_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Visit Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_gallery_blurb"
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Gallery</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Discover dog-friendly apartments in Meridian, Idaho. Enjoy pet-friendly living spaces tailored for you and your furry friends.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Dog-Friendly Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Interactive Map</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Have questions about how to start living at your new home? Our dedicated leasing team at <span data-type=\"field-token\" data-field=\"property_name\"></span> is here to assist you.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Let's Connect</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_neighborhood_blurb"
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Neighborhood</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Pet Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyinfo.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.info": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.restrictions": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_restrictions"
  },
  "petpolicyinfo.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Privacy Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_long_description"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Luxury Apartment Living</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_residentaccess_blurb"
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Resident Access</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.help_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Need Help? Call Us</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.portal_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resident Portal</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Schedule A Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Sitemap</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "testimonials.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Testimonials</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Thank You</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_virtualtours_blurb"
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Virtual Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "whitestripe.apply_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_applynow_blurb"
  }
};

export const slotGroupOverrides = {
  "conveniencecallout.background": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "conveniencecallout.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "conveniencecallout.feature_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "floorplanslist.feature_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "floorplanslist.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Interior view of a modern apartment, showing the kitchen area and a spacious empty living room with a sliding glass door."
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Choose Your Home"
      }
    }
  },
  "manualfloorplans.plan_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-1d82-7683-97cc-9d51a1a1d9b3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "S1 studio floor plan line drawing, 605 sq ft with one bathroom"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "S1"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "Studio"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "605"
      }
    }
  },
  "manualfloorplans.plan_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-4060-705b-8d12-83bbb1350235.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A1 one-bedroom floor plan line drawing, 650 sq ft with one bathroom"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "A1"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "650"
      }
    }
  },
  "manualfloorplans.plan_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-1f22-7367-be71-6fbea92b826e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "B1 two-bedroom floor plan line drawing, 1,033 sq ft with two bathrooms"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "B1"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1,033"
      }
    }
  },
  "manualfloorplans.plan_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-4425-71c9-80d4-a6171c4609df.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "C1 three-bedroom floor plan line drawing, 1,298 sq ft with two bathrooms"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "C1"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "3"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1,298"
      }
    }
  },
  "photoslider.slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-88cb-760e-90d7-a12c26011985.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style swimming pool with lounge chairs and a seating area."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Resort-Style Pool"
      }
    }
  },
  "photoslider.slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-c69e-770b-96ff-01e05f016477.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a leather sofa, armchair, and open kitchen."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-Concept Living"
      }
    }
  },
  "photoslider.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-dc29-754f-a1cf-781eab30578d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a king-size bed and a view into the bathroom."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Spacious Bedrooms"
      }
    }
  },
  "photoslider.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-fc27-759a-8c04-f2e32dc131a5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a large island with bar stools."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Chef-Ready Kitchens"
      }
    }
  },
  "photoslider.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-b77c-7429-a3a4-5cb7a5882333.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Stylish communal lounge area with green sofas, tufted brown sofa, wicker coffee table, and wall art."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Resident Lounge"
      }
    }
  },
  "photoslider.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-ac47-707e-8bf5-8dc726dc90f9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with exercise bikes, rowing machines, and stability balls."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "photoslider.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      0,
      1,
      2,
      3,
      7,
      11,
      10,
      9
    ],
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      22,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "tiktok-pixel",
      "blockId": "tiktok-pixel",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
